"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = interpret;
exports.buildAmountRule = buildAmountRule;
exports.buildExactlyRule = buildExactlyRule;
exports.combineValuesWithOperator = combineValuesWithOperator;
exports.buildSumOfRule = buildSumOfRule;
exports.buildProductOfRule = buildProductOfRule;
exports.buildDifferenceOfRule = buildDifferenceOfRule;
exports.buildGreaterOfRule = buildGreaterOfRule;
exports.buildLesserOfRule = buildLesserOfRule;
exports.buildIfSubRuleSelector = buildIfSubRuleSelector;
exports.buildAnyOfSubRuleSelector = buildAnyOfSubRuleSelector;
exports.buildAllOfSubRuleSelector = buildAllOfSubRuleSelector;
exports.getRuleBuilderForRule = void 0;

var _atom = require("../../utils/atom");

function interpret() {
  var rules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (!rules.length) {
    return 0;
  }

  return buildAmountRule(rules[0]);
}

var ruleBuilderDispatch = {
  amountTypeSelector: {
    exactly: buildExactlyRule,
    sumOf: buildSumOfRule,
    productOf: buildProductOfRule,
    differenceOf: buildDifferenceOfRule,
    greaterOf: buildGreaterOfRule,
    lesserOf: buildLesserOfRule
  },
  subRuleSelector: {
    if: buildIfSubRuleSelector,
    anyOf: buildAnyOfSubRuleSelector,
    allOf: buildAllOfSubRuleSelector
  }
};
var getRuleBuilderForRule = (0, _atom.makeRuleBuilder)(ruleBuilderDispatch);
exports.getRuleBuilderForRule = getRuleBuilderForRule;

function buildAmountRule(rule) {
  return (0, _atom.buildRule)(getRuleBuilderForRule, rule);
}

function buildExactlyRule(valueFinder) {
  var exactlyAmount = valueFinder("exactlyAmount");
  return function () {
    return exactlyAmount;
  };
}

function combineValuesWithOperator(op, a, b) {
  if (a === undefined && b === undefined) {
    return 0;
  }

  if (a === undefined) {
    return b;
  }

  if (b === undefined) {
    return a;
  }

  if (a === Infinity || b === Infinity) {
    return Infinity;
  }

  switch (op) {
    case "+":
      return a + b;

    case "*":
      return a * b;

    case "-":
      return a - b;

    case ">":
      return a >= b ? a : b;

    case "<":
      return a <= b ? a : b;

    default:
      throw new Error("Cannot combine values with operator ".concat(op));
  }
}

function buildSumOfRule(valueFinder) {
  return function (val, obj, subRules) {
    return subRules.reduce(function (bucket, amount) {
      return combineValuesWithOperator("+", bucket, amount);
    }, 0);
  };
}

function buildProductOfRule(valueFinder) {
  return function (val, obj, subRules) {
    return subRules.reduce(function (bucket, amount) {
      return combineValuesWithOperator("*", bucket, amount);
    }, 1);
  };
}

function buildDifferenceOfRule(valueFinder) {
  return function (val, obj, subRules) {
    var minuend = subRules.shift();
    var res = subRules.reduce(function (bucket, amount) {
      return combineValuesWithOperator("-", bucket, amount);
    }, minuend);
    return res;
  };
}

function buildGreaterOfRule(valueFinder) {
  return function (val, obj, subRules) {
    return subRules.reduce(function (bucket, amount) {
      return combineValuesWithOperator(">", bucket, amount);
    }, Number.MIN_VALUE);
  };
}

function buildLesserOfRule(valueFinder) {
  return function (val, obj, subRules) {
    return subRules.reduce(function (bucket, amount) {
      return combineValuesWithOperator("<", bucket, amount);
    }, Number.MAX_VALUE);
  };
}

var relativeAmountDispatch = {
  greater: function greater(val, check) {
    return val > check ? val : 0;
  },
  less: function less(val, check) {
    return val < check ? val : 0;
  },
  equals: function equals(val, check) {
    return val === check ? val : 0;
  }
};

function buildIfSubRuleSelector(valueFinder) {
  var ifBalanceValue = valueFinder("ifBalanceSelector");

  switch (ifBalanceValue) {
    case "eventAmount":
      {
        var relativeAmountSelector = valueFinder("relativeAmountSelector");
        var ifAmount = valueFinder("ifAmount");
        return function (value) {
          return relativeAmountDispatch[relativeAmountSelector](value, ifAmount);
        };
      }

    case "destinationAccount":
    case "sourceAccount":
      throw new Error("Cannot build if sub rule sourceAccount/destinationAccount not implemented");

    default:
      throw new Error("Cannot build if sub rule w/ ".concat(ifBalanceValue));
  }
}

function buildAnyOfSubRuleSelector(valueFinder) {
  return function (val, obj, subRules) {
    var anyValid = subRules.reduce(function (currentValid, subRuleFunc) {
      // any of them...so the new value is non-zero and we keep it, or it is zero, so we use the old one.
      return currentValid || subRuleFunc(val);
    }, false);
    return anyValid ? val : 0;
  };
}

function buildAllOfSubRuleSelector(valueFinder) {
  return function (val, obj, subRules) {
    var allValid = subRules.reduce(function (currentValid, subRuleFunc) {
      // just continue the stream.
      return currentValid && subRuleFunc(val);
    }, true);
    return allValid ? val : 0;
  };
}